module.exports = __webpack_public_path__ + "static/media/breadcrumb.b4e899a0.jpg";